import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectInstances = (store: StoreSchema) =>
	store.instances.paginatedInstances.items
